import { render, staticRenderFns } from "./Diversity.vue?vue&type=template&id=399ba754&scoped=true&"
import script from "./Diversity.vue?vue&type=script&lang=js&"
export * from "./Diversity.vue?vue&type=script&lang=js&"
import style0 from "./Diversity.vue?vue&type=style&index=0&id=399ba754&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399ba754",
  null
  
)

export default component.exports